<div class="reg_container">
    <div class="Page_container">
        <div class="reg_content">
            <div class="title_content">
                <h2>Todas las normas <br> por las que nos regimos.</h2>
            </div>
            <div class="columns">
                <div class="body-content">
                    <p><span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> se constituyó por escritura otorgada ante
                        el Notario de Oviedo D. José Herrero González Solar el 6 de marzo de 1984 y se inscribió en el
                        Registro Mercantil de Oviedo de fecha 4 de abril de 1984, al Tomo 477 del archivo, libro 309 de
                        la sección 3ª de Sociedades, folio 1, hoja número 1079, inscripción primera.</p>

                    <p>La Sociedad requirió autorización previa de la Dirección General del Tesoro y Política Financiera
                        del Ministerio de Economía y Hacienda que le fue concedida el 4 de noviembre de 1983.</p>

                    <p><span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> figura en el Registro Especial de
                        Establecimientos Financieros de Crédito con el número 8769. Su Código de Identificación Fiscal
                        es A/33053984.</p>

                    <p>Según el artículo 3º de los Estatutos Sociales, el tiempo de duración de la sociedad será
                        indefinido.</p>

                    <p>Su domicilio social se encuentra en la Calle Pelayo, 15 (entrada pasaje) de Oviedo, en donde se
                        pueden consultar los Estatutos de la Sociedad y demás información pública de la misma.</p>

                    <p><span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> es una entidad financiera Española sujeta
                        a la supervisión del Banco de España.</p>

                    <p>La página web de <span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> tiene por objeto
                        facilitar el conocimiento por el público en general de <span>UNIÓN FINANCIERA ASTURIANA S.A.
                            E.F.C.</span>, de las actividades que realiza y de los servicios que presta.</p>

                    <p><span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> se reserva el derecho a actualizar,
                        modificar o eliminar, en cualquier momento y sin previo aviso, la información contenida en su
                        página web, la página web misma o la configuración y presentación de ésta, así como a restringir
                        o no permitir el acceso a dicha información.</p>

                    <p>El acceso a la página web de <span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> y cualquier
                        uso de la información contenida en el mismo es exclusiva responsabilidad de quien lo realiza.
                        <span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> no responderá de ninguna consecuencia,
                        daño o perjuicio que se deriven de dicho acceso o uso de la información que la página web
                        contenga.</p>

                    <p><span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> no se responsabiliza de las posibles
                        diferencias que puedan existir entre sus documentos impresos y la versión electrónica de los
                        mismos contenidos en su página web.</p>

                    <p><span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> no garantiza que la información, texto,
                        gráficos, vínculos o el contenido de todos los artículos contenidos en la página web de
                        <span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> sean exactos o completos, y
                        <span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span>, expresamente, rechaza cualquier
                        responsabilidad por errores u omisiones en estos elementos.</p>

                    <p>Las eventuales referencias que se hagan en la página web de <span>UNIÓN FINANCIERA ASTURIANA
                            S.A. E.F.C.</span> a cualquier producto, servicio, proceso, enlace, hipertexto o cualquier
                        otra información utilizando la marca, el nombre comercial o el fabricante o suministrador, etc.,
                        que sean de la titularidad de terceros no constituyen ni implican respaldo, patrocinio o
                        recomendación por parte de <span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span>.</p>

                    <p>Queda expresamente prohibida la reproducción total o parcial, ni aun citando las fuentes, así
                        como cualesquiera usos, de cualesquiera contenidos incluidos en la página web, y de la página
                        web misma en su conjunto, salvo autorización escrita de <span>UNIÓN FINANCIERA ASTURIANA S.A.
                            E.F.C.</span>. El logo de <span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> es una
                        marca registrada e identificativa.</p>

                    <h3>Información consumidor ley de comercialización a distancia de servicios financieros</h3>

                    <p><span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> le informa que:</p>

                    <p>De acuerdo con lo establecido en la Ley 22/2007, de 11 de julio, sobre comercialización a
                        distancia de servicios financieros destinados a los consumidores, los clientes que contraten un
                        préstamo o crédito con <span>UNIÓN FINANCIERA ASTURIANA S.A. E.F.C.</span> a través de una
                        técnica de comunicación a distancia (Internet, medios telefónicos, etc.) dispondrán de un plazo
                        de 14 DÍAS desde la fecha del contrato para desistir del mismo. En caso de que el titular/es
                        haya dispuesto del crédito concedido o recibido el importe del préstamo en la cuenta corriente
                        designada, para ejercitar el derecho de desistimiento deberá reintegrar la cantidad total
                        dispuesta, incluidos los intereses devengados, antes de que transcurran treinta días desde el
                        ejercicio del derecho de desistimiento.</p>

                    <p>Para ejercer este derecho el titular deberá remitir escrito por correo con acuse de recibo u otro
                        medio que permita acreditar el envío y recepción, dirigido a <span>UNIÓN FINANCIERA ASTURIANA
                            S.A. E.F.C.</span>, C/ Pelayo, 15 (entrada pasaje) – 33003 Oviedo (ASTURIAS).</p>

                    <h3>Servicio de reclamaciones</h3>

                    <p>Existen y se encuentran disponibles para el público las tarifas de comisiones y gastos
                        repercutibles, así como las normas de valoración de esta entidad, que fueron registrados por el
                        Banco de España. Esta información también se encuentra disponible en la página web de esta
                        entidad: <a href="http://www.unionfinanciera.es" target="_blank">www.unionfinanciera.es</a></p>

                    <p>Los clientes tienen derecho a solicitar una oferta vinculante, relativa a las condiciones del
                        crédito al consumo que pretendan solicitar. Dicha oferta vincula a la entidad exclusivamente
                        respecto de las condiciones de dicho crédito y por el plazo legalmente establecido, sin que
                        dicha oferta suponga la concesión del crédito por parte de la entidad, quien tras el análisis
                        crediticio del cliente decidirá sobre su concesión o denegación. La solicitud y entrega de dicha
                        oferta tendrá carácter gratuito.</p>

                </div>
                <div class="forms_container">
                    <div class="generalConditions">
                        <h2>Condiciones generales</h2>
                        <p (click)="onDownload()" class="download-link">Descargar condiciones generales</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer-landing></app-footer-landing>